import { render, staticRenderFns } from "./form-table-item.vue?vue&type=template&id=51e3dd25&scoped=true&"
import script from "./form-table-item.vue?vue&type=script&lang=js&"
export * from "./form-table-item.vue?vue&type=script&lang=js&"
import style0 from "./form-table-item.vue?vue&type=style&index=0&id=51e3dd25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e3dd25",
  null
  
)

component.options.__file = "form-table-item.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/FormTable/form-table-item.vue
// module id = null
// module chunks = 